export default function numberToString(n)
{
  return n.toLocaleString();
}
